import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { wizard, meta } from 'helpers/decorators'
import { Address, PersonalDetails } from 'components/forms'
import { Button, FormDebug } from 'components/misc'
import {
  apiCodeLists,
  apiCommon,
  apiConfiguration
} from 'helpers/decorators/api'
import validate from './leader-details.validation'
import { CONFIGURATION_KEYS } from 'constants/enums'

@apiConfiguration()
@wizard({
  form: 'leaderRegistration',
  multipage: true,
  validate: (fields, props) =>
    validate(fields, props, {
      leaderMinAge: CONFIGURATION_KEYS.leaderMinAge.id
    }),
  destroyOnUnmount: false
})
@apiCommon({
  publicCountries: true,
  publicRegions: true
})
@apiCodeLists(['genders', 'titles', 'employmentStatuses', 'nationalities'], {
  public: true
})
@meta({
  title: 'Leader Details',
  intlKey: 'wizard.leader_details'
})
class LeaderDetails extends Component {
  static propTypes = {
    values: PropTypes.object,
    errors: PropTypes.object,
    codeLists: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    common: PropTypes.object.isRequired,
    isConfigurationTrue: PropTypes.func.isRequired
  }

  componentDidMount = () => {
    const { values } = this.props

    this.props.onGetConfigurationValue(
      CONFIGURATION_KEYS.leaderMinAge.id,
      get(values, 'organizationId')
    )
  }

  render() {
    const { handleSubmit, onSubmit, values, codeLists, common, configuration } = this.props

    const minAgeCfg = get(configuration, `values[${CONFIGURATION_KEYS.leaderMinAge.id}].intValue`)

    const showDateOfBirth = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactDateOfBirth.id)

    const showCountry = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressCountry.id)

    const showMiddleName = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactMiddleName.id)

    const showGender = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactGender.id)

    const showFirstLine = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressLine1.id)

    const showSecondLine = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressLine2.id)

    const showCity = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressCity.id)

    const showZipCode = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressZipCode.id)

    const showRegion = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressRegion.id)

    const showTitle = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactTitle.id)

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <PersonalDetails
          titles={codeLists.titles.list}
          genders={showGender && codeLists.genders.list}
          isOrganizationContact
          minAgeCfg={minAgeCfg}
          showDateOfBirth={showDateOfBirth}
          showMiddleName={showMiddleName}
          showTitle={showTitle}
          errors={this.props.errors}
        />

        <Address
          showFirstLine={showFirstLine}
          showSecondLine={showSecondLine}
          showCity={showCity}
          showZipCode={showZipCode}
          showRegion={showRegion}
          countries={showCountry && common.countries.list}
        />
        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
        <FormDebug values={values} />
      </form>
    )
  }
}

export default LeaderDetails
